import { useEffect, useRef, useState } from "react";
import cookies from "js-cookie";
import { MdOutlineGridView, MdOutlineLogout } from "react-icons/md";

const DropdownMain = ({ userData }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [userAvatar, setUserAvatar] = useState("");
  const dropdownRef = useRef(null);

  const getInitials = (name) => {
    if (!name) return "U";
    let initialArray = name.trim().split(" ");
    if (initialArray.length > 2) {
      initialArray = initialArray.slice(0, 2);
    }
    return initialArray
      .map((part) => part[0])
      .join("")
      .toUpperCase();
  };

  const handleRedirectToDashboard = () => {
    window.location.href =
      process.env.REACT_APP_PUBLIC_TESTINGDASH_NAVBAR_ROUTE_URL || "/dashboard";
  };

  const getDomain = () => {
    const hostname = window.location.hostname;
    return hostname === "localhost"
      ? undefined
      : process.env.REACT_APP_PUBLIC_COMMON_PROD_URL;
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      const avatar = cookies.get("avatar");
      setUserAvatar(avatar);
    }
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const displayName = userData?.full_name || userData?.name || "aman";
  const displayEmail =
    userData?.email || userData?.username || "aman.tomar@digimonk.in";

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2.5 focus:outline-none cursor-pointer group"
      >
        <span className="text-white font-medium text-sm md:text-base hidden sm:inline-block max-w-[8rem] truncate">
          {displayName}
        </span>
        <div className="relative w-9 h-9 md:w-10 md:h-10 rounded-full border border-white/30 overflow-hidden shrink-0 group-hover:border-white/60 transition-colors">
          {userData?.profile?.image ? (
            <img
              src={userData?.profile?.src || userData?.profile?.image}
              alt="Avatar"
              className="w-full h-full object-cover"
            />
          ) : (
            <div
              className="flex items-center justify-center w-full h-full rounded-full text-white font-bold"
              style={{
                backgroundColor: userAvatar ? userAvatar : "#e617be",
              }}
            >
              <span className="text-sm md:text-base">
                {getInitials(displayName)}
              </span>
            </div>
          )}
        </div>
      </button>

      {isOpen && (
        <div
          className="absolute right-0 top-full mt-2 w-64 md:w-72 border rounded-lg shadow-2xl p-2 z-[9999999] text-white"
          style={{
            backgroundColor: "hsl(235.4, 17.8%, 14.3%)",
            borderColor: "hsl(240, 10%, 32%)",
          }}
        >
          {/* User Info Section */}
          <div className="px-3 pt-2.5 pb-2">
            <h4 className="text-base font-bold text-white leading-snug truncate">
              {displayName}
            </h4>
            <p className="text-xs text-gray-400 truncate mt-0.5 font-normal">
              {displayEmail}
            </p>
          </div>

          <div className="h-[1px] bg-white/10 my-1 w-full" />

          {/* Dashboard Link */}
          <button
            type="button"
            onClick={() => {
              handleRedirectToDashboard();
              setIsOpen(false);
            }}
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium text-white hover:bg-white/10 transition-colors text-left cursor-pointer"
          >
            <MdOutlineGridView size={20} className="text-gray-300 shrink-0" />
            <span>My Dashboard</span>
          </button>

          <div className="h-[1px] bg-white/10 my-1 w-full" />

          {/* Logout Button */}
          <button
            type="button"
            onClick={() => {
              cookies.remove("access", { domain: getDomain(), path: "/" });
              cookies.remove("planName", { domain: getDomain(), path: "/" });
              cookies.remove("refresh", { domain: getDomain(), path: "/" });
              cookies.remove("role", { domain: getDomain(), path: "/" });
              cookies.remove("userDetails", { domain: getDomain(), path: "/" });
              window.location.href =
                process.env.REACT_APP_PUBLIC_TESTINGLOGIN_NAVBAR_ROUTE_URL || "/login";
            }}
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium hover:bg-white/10 transition-colors text-left cursor-pointer"
            style={{ color: "rgb(253, 164, 175)" }}
          >
            <MdOutlineLogout size={20} className="shrink-0" style={{ color: "rgb(253, 164, 175)" }} />
            <span>Logout</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default DropdownMain;
